import React from "react";
import "./TermsAndConditions.css";

const TermsAndConditions = ({ open, onClose }) => {
    if (!open) return null;

    return (
        <div className="terms-backdrop">
            <div className="terms-modal">

                {/* Header */}
                <div className="terms-header">
                    <h3>Kanha WonderCraft – Terms & Conditions</h3>
                    <button className="terms-close-btn" onClick={onClose}>
                        ✕
                    </button>
                </div>

                {/* Body */}
                <div className="terms-body">
                    <p><strong>Last Updated:</strong> 1 February 2026</p>

                    <p>
                        This document is an electronic record in terms of the Information Technology Act, 2000
                        and rules thereunder. This electronic record is generated by a computer system and does
                        not require any physical or digital signatures.
                    </p>

                    <p>
                        These Terms and Conditions (“Terms”) govern your access to and use of the Kanha WonderCraft
                        website, mobile site, and related services (collectively, the “Platform”). By accessing,
                        browsing, or using the Platform, you acknowledge that you have read, understood, and agree
                        to be bound by these Terms.
                    </p>

                    <h4>1. Eligibility</h4>
                    <p>
                        You represent and warrant that you are competent to contract as per the Indian Contract Act, 1872.
                        If you are a minor, you may use the Platform only under the supervision of a parent or legal guardian.
                    </p>

                    <h4>2. User Account</h4>
                    <p>
                        You may be required to register and create an account to access certain features. You are responsible
                        for maintaining the confidentiality of your account credentials and for all activities that occur
                        under your account.
                    </p>

                    <h4>3. Platform Services</h4>
                    <p>
                        Kanha WonderCraft operates an e-commerce platform offering various products and services including,
                        but not limited to, stationery, toys, Laddu Gopal dresses, religious and devotional items, CSC-related
                        services, and other related offerings.
                    </p>

                    <h4>4. Pricing and Availability</h4>
                    <p>
                        All prices, product descriptions, and availability information are subject to change without prior
                        notice. While reasonable efforts are made to ensure accuracy, errors may occur. Kanha WonderCraft
                        reserves the right to correct any errors and to cancel or refuse any order placed for a product
                        listed at an incorrect price.
                    </p>

                    <h4>5. Orders and Payments</h4>
                    <p>
                        Your order constitutes an offer to purchase products or services. All orders are subject to
                        acceptance by Kanha WonderCraft. Payments must be made through authorized payment methods available
                        on the Platform. Kanha WonderCraft shall not be liable for payment failures caused by third-party
                        payment gateways or banking partners.
                    </p>

                    <h4>6. Shipping and Delivery</h4>
                    <p>
                        Delivery timelines provided are estimates only and may vary due to factors beyond our control,
                        including logistics partner delays, force majeure events, or address verification issues.
                        Kanha WonderCraft shall not be responsible for delays caused by third-party logistics providers.
                    </p>

                    <h4>7. Cancellations, Returns, and Refunds</h4>
                    <p>
                        Cancellation, return, and refund requests shall be governed by Kanha WonderCraft’s Return and
                        Refund Policy, as updated from time to time. Certain categories of products, including customized,
                        perishable, devotional, or hygiene-related items, may be non-returnable in accordance with
                        applicable laws and internal policies.
                    </p>

                    <h4>8. Intellectual Property Rights</h4>
                    <p>
                        All content on the Platform, including but not limited to text, images, logos, graphics, designs,
                        and software, is the exclusive property of Kanha WonderCraft and is protected by applicable
                        intellectual property laws. Unauthorized use, reproduction, or distribution is strictly prohibited.
                    </p>

                    <h4>9. User Obligations</h4>
                    <p>
                        You agree not to use the Platform for any unlawful purpose, to upload or transmit any harmful code,
                        or to engage in any activity that may disrupt or interfere with the functioning of the Platform.
                    </p>

                    <h4>10. Limitation of Liability</h4>
                    <p>
                        To the maximum extent permitted by law, Kanha WonderCraft shall not be liable for any indirect,
                        incidental, special, or consequential damages. Kanha WonderCraft’s total liability, if any,
                        shall be limited to the amount paid by you for the specific product or service giving rise to
                        the claim.
                    </p>

                    <h4>11. Indemnity</h4>
                    <p>
                        You agree to indemnify and hold harmless Kanha WonderCraft, its owners, affiliates, and employees
                        from and against any claims, liabilities, damages, and expenses arising out of your use of the
                        Platform or violation of these Terms.
                    </p>

                    <h4>12. Governing Law and Jurisdiction</h4>
                    <p>
                        These Terms shall be governed by and construed in accordance with the laws of India. Any disputes
                        shall be subject to the exclusive jurisdiction of the courts located in Delhi, India.
                    </p>

                    <h4>13. Changes to Terms</h4>
                    <p>
                        Kanha WonderCraft reserves the right to modify these Terms at any time. Updated Terms will be
                        effective upon posting on the Platform. Your continued use of the Platform constitutes your
                        acceptance of such changes.
                    </p>
                </div>


                {/* Footer */}
                <div className="terms-footer">
                    <button className="terms-close-primary" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
